import { render, staticRenderFns } from "./SimpelbangCharts.vue?vue&type=template&id=ce618e12&scoped=true&"
import script from "./SimpelbangCharts.vue?vue&type=script&lang=js&"
export * from "./SimpelbangCharts.vue?vue&type=script&lang=js&"
import style0 from "./SimpelbangCharts.vue?vue&type=style&index=0&id=ce618e12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce618e12",
  null
  
)

export default component.exports